module.exports = __webpack_public_path__ + "img/other_meizu2.b994e042.jpg";